import { countryCodesMap } from "../data/countries";

export const addressToString = (val, includeAdd2) => {
  if (!val) return "";

  return ["StreetAddress", "Locality", "AdministrativeArea", "PostCode", "Country"].reduce(
    (agg, field) => {
      if (!val[field]) return agg;
      let value = val[field];
      if (field === "Country") value = countryCodesMap[value];
      if (field === "StreetAddress") return agg + (includeAdd2 ? value.join(", ") : value[0]);
      if (!agg) return value;
      if (field === "PostCode") return agg + " " + value;
      return agg + ", " + value;
    },
    ""
  );
};
